export const isDev = () => {
	return (window.location.hostname == 'localhost' || window.location.hostname.indexOf('ngrok') != -1)
}
export const inIframe = () => {
	try {
		return window.self !== window.top
	} catch (e) {
		return true
	}
}
export const throttle = (fn, wait) => {
	let time = Date.now()
	return function() {
		if ((time + wait - Date.now()) < 0) {
			fn()
			time = Date.now()
		}
	}
}
export const getDzPos = () => {
	if (inIframe()) {
		let $iframe = parent.document.querySelector('.dz-js-dataviz')
		if (!$iframe) $iframe = parent.document.querySelector('body > iframe')
		if (!$iframe) return 0

		return $iframe.getBoundingClientRect().top + window.parent.scrollY
	} else {
		return 0
	}
}
export const isEdge = () => {
	if (/Edge\/\d./i.test(navigator.userAgent)) return true
}
export const getSection = (def='pouvoirs') => {
	try {
		return parent.document.location.pathname.match(/\/article\/(.+)\//)[1]
	}
	catch(e) {
		return def
	}
}
export const smoothScroll = (target, callback) => {
	let currentPos = window.parent.scrollY
	let distance = target - currentPos,
	frames = 40,
	currentFrame = 0,
	time = 700,
	delta = distance / frames,
	timer
	timer = setInterval(() => {
		if (currentFrame <= frames) {
			let pos = Math.round(currentPos + currentFrame * (delta))
			if (isEdge()) {
				parent.window.scrollTo(0,pos)
			} else {
				window.parent.scroll({top: pos})
			}
		} else {
			clearInterval(timer)
			if (callback != undefined) callback()
		}
	currentFrame++
}, Math.floor(time / frames))
}
export const hideLoader = () => {
	if (inIframe()) {
		let $loader = parent.document.querySelector('.dz-js-loading')
		let $dataviz = parent.document.querySelector('.dz-js-dataviz')
		$loader.style.display = 'none'
		$dataviz.style.opacity = 1
	}
}
export const toLocale = (text, digits) => {
	let number = parseFloat(text)
	if (digits != 0) {
		number = number.toLocaleString('fr-FR', {
			maximumSignificantDigits: digits
		})
	} else {
		number = number.toLocaleString('fr-FR')
	}

	return number
}
export const isOverflowing = ($el) => {
	let overflowOffset = 0
	let curOverflow = $el.style.overflow
	if (!curOverflow || curOverflow === 'visible')
		$el.style.overflow = 'hidden'
	let isOverflowing = $el.clientHeight < ($el.scrollHeight + overflowOffset)
	$el.style.overflow = curOverflow

	return isOverflowing
}
export const redirectDirectAccess = (id, type='article') => {
	if (!isDev() && !inIframe()) {
		let url = 'https://www.contexte.com/admin/r/'
		let paths = {
			article: '29/',
			hub: '215/',
			special: '239/', 
		}
		url += paths[type]
		url += id
		window.open(url, '_self')
	}
}
export const redirectDirectAccessToUrl = (url='https://fr.wikipedia.org') => {
	if (!isDev() && !inIframe()) {
		window.open(url, '_self')
	}
}
export const isEmpty = (obj) => {
	for (let i in obj) return false
		return true
}
export const parentUrl = () => {
	if (inIframe()) return new URL(parent.document.location.href)
		return new URL(document.location.href)
}
export const normalize = (string, dropSpaces=false, replaceHyphensBy='') => {
	let normalized = string.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\.|\?|!|,|\(|\)|\[|\]|;|,/g,'').toLowerCase()
	normalized = normalized.replace(/'|’/g, ' ')
	normalized = normalized.replace(/-|—|–/g, replaceHyphensBy)
	if (dropSpaces) {
		return normalized.replace(/\s/g,'')
	} else {
		return normalized
	}
}
export const isIos = () => {
	var iDevices = [
	'iPad Simulator',
	'iPhone Simulator',
	'iPod Simulator',
	'iPad',
	'iPhone',
	'iPod'
	]
	if (!!navigator.platform) {
		while (iDevices.length) {
			if (navigator.platform === iDevices.pop()){ return true }
		}
}
return false
}
export const setUpdateDate = (date) => {
	let trueDate = new Date(date)
	date = trueDate.toLocaleString('fr-FR', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
		hour: 'numeric',
		minute: '2-digit'
	}).replace(':',' h ')
	let $updated = parent.document.querySelector('.article-header-meta-update-date')
	if ($updated != null) $updated.textContent = '| mis à jour le ' + date
} 
export const isFirefox = () => {
	return navigator.userAgent.toLowerCase().indexOf('firefox') > -1
}
export const hashString = str => {
	let hash = 0
	for (let i = 0; i < str.length; ++i)
		hash = (Math.imul(31, hash) + str.charCodeAt(i)) | 0

	return hash
}
export const clone = obj => {
	
	return JSON.parse(JSON.stringify(obj))
}
export const hex2rgba = (hex, alpha = 1) => {
	const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16))

	return `rgba(${r},${g},${b},${alpha})`
}
export const attributeColors = (items, pallet) => {
	items.map((item, idx) => {
		let i = idx	
		let j = 1
		while (i > pallet.length-1) {
			i = idx - j * pallet.length
			j++
		}
		item.color = pallet[i]
	})

	return items
}
export const makeParagraphs = (items, keys) => {

	items.forEach(item => {
		keys.forEach(key => {
			if (!item[key].includes('<p>') && !item[key].includes('<ul>') && !!item[key]) item[key] = '<p>' + item[key] + '</p>'
		})
	})

	return items
}
export const getWordings = (config) => {
	let wordings = {}
	for (let key in config) {
		if (key.includes('wording_')) wordings[key.replace('wording_','')] = config[key]
	}

	return wordings
}
export const shuffleArray = (array) => {
  let currentIndex = array.length, randomIndex
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]]
  }

  return array
}
export const padNumber = (number, digits) => {
	let abs = Math.abs(number)
	let string = ''
	if (number < 0) string += '-'
	return string + String(abs).padStart(digits, '0')
}
export const isSafari = () => {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
export const preventSvgOverlap = ($els, sort=true, offset=0) => {
	if (sort) {					
		let els = []
		$els.map($el => {
			els.push({
				top: $el.getBBox().y,
				$el: $el,
			})
		})
		els.sort((a,b) => {
			return a.top - b.top
		})
		$els = els.reduce((agg, el) => {
			return agg.concat(el.$el)
		}, [])
	}

	let hasOverlap = false
	Array.from($els).map(($el, e) => {
		if (e > 0) {
			let bottomA = $els[e-1].getBBox().y + $els[e-1].getBBox().height
			let topB = $el.getBBox().y
			let rightA = $els[e-1].getBBox().x + $els[e-1].getBBox().width
			let leftB = $el.getBBox().x
			if (bottomA > topB && leftB < rightA) {
				hasOverlap = true
				$el.setAttribute('y', parseFloat($el.getAttribute('y')) + (bottomA - topB) + offset )
			}
		}
	})
	if (hasOverlap) preventSvgOverlap($els)
}

